import { render, staticRenderFns } from "./TemplateBlock.vue?vue&type=template&id=3f1e866c&scoped=true"
import script from "./TemplateBlock.vue?vue&type=script&lang=js"
export * from "./TemplateBlock.vue?vue&type=script&lang=js"
import style0 from "./TemplateBlock.vue?vue&type=style&index=0&id=3f1e866c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1e866c",
  null
  
)

export default component.exports